import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import { getLogoEmpresa } from "../../../../actions/operaciones/operaciones.actions"
import { Pagination } from "../../../../components/Pagination"
import useCreditoFiscal, { montosDeLineaCcf } from "../../../../actions/credito-fiscal.actions"
import TablaDocsAsociados from "../../../EmitirFactura/Components/GeneracionFactura/TablaDocsAsociados"
import { unirChipsJoin, unirChipsReturnFirst } from "../../../../utils/strings.utils"
import { formatearNum, formatearNumEmpresa, processDetalleImpuestosHTML, getDigitosCalculables } from "../../../../actions/utils-documentos.actions"
import FilaDistritoDTE from "../CamposV2/FilaDistritoDTE";
import {TIPO_DTE, versionDteEmision} from '../../../../utils/version-documento.utils'

import FilaDistritoEmisor from "../CamposV2/FilaDistritoEmisor";
export default function DTECreditoFiscal (){
    const {formCliente, productos, response_QRcode, view, tableProductos, notasRemisionAsociadas} = useSelector((state: State) => state.creditoFiscal )
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datosEmisor, tipoDocumento, actividadesEconomicas, municipios, departamentos, unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    const {datos} = useSelector((state: State) => state.userLogin)
    const {setTableProductos, calculosProductos} = useCreditoFiscal()
    const sucursal = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.nombre
    const documento = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.Documento?.find((doc: any) => doc.idsucursaldocumento === formCliente.serie)
    const serie = `${documento?.serie}-${documento?.numeroactual}`
    const {dataDocsAsociados} = useSelector((state: State) => state.documentos.otrosDocumentosAsociados)
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form)
    const propinaConfig = useSelector((state: State) => state.userLogin.propina);
    const { propina_activa, cantidad_propina } = propinaConfig;

    return (
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout w-100' >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell w-100' >
        <div className="card">
            <div className="dte-title">
                <label>{view === 'Previsualizacion' ? 'PREVISUALIZACIÓN DE ' : '' }DOCUMENTO TRIBUTARIO ELECTRÓNICO</label>
                <label>CRÉDITO FISCAL</label>
            </div>
            <div className="separador" />
            <div className='dt-card-grid-2c-1r' style={{alignItems: 'center'}}>
                <div className='dt-card-2c-1r-no-border' style={{textAlign: 'center'}}>
                    <img alt="Logo" src={getLogoEmpresa()} className='logo-itprofis'/>
                </div>
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <table className="dte-table">
                        <tr>
                            <td>Documento Tributario Electrónico Versión:</td>
                            <td>{versionDteEmision(TIPO_DTE.CREDITO_FISCAL, datosEmisor) || ''}</td>
                        </tr>
                        <tr>
                            <td>Código de Generación:</td>
                            <td>{datosUUID?.CodigoGeneracion}</td>
                        </tr>
                        <tr>
                            <td>Sucursal:</td>
                            <td>{sucursal}</td>
                        </tr>
                        <tr>
                            <td>Serie:</td>
                            <td>{serie}</td>
                        </tr>
                        <tr>
                            <td>Moneda:</td>
                            <td>USD - Dólar estadounidense</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className='dt-card-grid-2c-1r'>
            {/* DATOS DEL RECEPTOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                <div className='dt-center-content'>
                    <label className="dte-subsection-title">Receptor</label>
                    <table className="dte-table">
                        <tr><td>Nombre:</td><td>{formCliente?.nombre}</td></tr>
                        <tr><td>NIT:</td><td>{formCliente?.noDocumento}</td></tr>
                        <tr><td>NRC:</td><td>{formCliente?.nrc}</td></tr>
                        <tr><td>Actividad económica:</td><td>{actividadesEconomicas.find((actividad) => actividad.codigo === formCliente?.actividad)?.valor}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{formCliente?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{unirChipsReturnFirst(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                        <tr><td>Dirección:</td><td>{formCliente?.direccion}</td></tr>
                        <tr><td>Departamento:</td><td>{departamentos.find((departamento) => departamento.codigo === formCliente?.departamento)?.valor?.toUpperCase() }</td></tr>
                        <tr><td>Municipio:</td><td>{municipios.find((municipio) => municipio.codigo === formCliente?.municipio)?.valor?.toUpperCase() }</td></tr>
                        <FilaDistritoDTE distrito = {formCliente?.distrito}/>
                        <tr><td>Envío de documento por correo electrónico a:</td><td>{unirChipsJoin(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                    </table>
                </div>
                </div>
                {/* DATOS DEL EMISOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <div className='dt-center-content'>
                    <label className="dte-subsection-title">Emisor</label>
                    <table className="dte-table">
                        <tr><td>Tipo de persona:</td><td>{datosEmisor?.desTipoEmpresa ?? ''}</td></tr>
                        <tr><td>Tipo de contribuyente:</td><td>{datosEmisor?.desContribuyente ?? ''}</td></tr>
                        <tr><td>Nombre del cliente:</td><td>{datosEmisor?.nombre}</td></tr>
                        <tr><td>Dirección:</td><td>{datosEmisor?.complemento}</td></tr>
                        <tr><td>Departamento:</td><td>{datosEmisor?.departamentonombre}</td></tr>
                        <tr><td>Municipio:</td><td>{datosEmisor?.municipionombre}</td></tr>
                        <FilaDistritoEmisor />
                        <tr><td>Giro:</td><td>{datosEmisor?.descactividad}</td></tr>
                        <tr><td>NIT:</td><td>{datosEmisor?.nit}</td></tr>
                        <tr><td>NRC:</td><td>{datosEmisor?.nrc}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{datosEmisor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{datosEmisor?.correo}</td></tr>
                    </table>
                </div>
                </div>
            </div>
            {notasRemisionAsociadas.length > 0 &&
            <div className="dte-section">
                <div className="dte-subsection">
                    <label className="dte-subsection-title">Documentos asociados</label>
                    <div className="tab-plane">
                        <table className="table-main-responsive responsive-table-main td-left table-pointer">
                            <thead>
                                <tr>
                                    <td style={{textAlign: 'left'}}>Correlativo</td>
                                    <td style={{textAlign: 'left'}}>Tipo de documento</td>
                                    <td style={{textAlign: 'left'}}>Emisión</td>
                                </tr>
                            </thead>
                            {notasRemisionAsociadas.map((documento, index) => (
                                <tr key={index}>
                                    <td data-label="Correlativo" style={{textAlign: 'left'}}>{documento?.codigogeneracion}</td>
                                    <td data-label="Tipo de documento" style={{textAlign: 'left'}}>{'Nota de remisión'}</td>
                                    <td data-label="Emisión" style={{textAlign: 'left'}}>{ `${documento?.DetallesDTE?.identificacion?.fecEmi?.split('-')[2]}/${documento?.DetallesDTE?.identificacion?.fecEmi?.split('-')[1]}/${documento?.DetallesDTE?.identificacion?.fecEmi?.split('-')[0]}`}</td>
                                </tr>
                            ))}
                        </table>
                    </div>
                </div>
            </div>
            }

            {/* TABLA DE OTROS DOCUMENTOS RELACIONADOS */}
            {
            dataDocsAsociados.length > 0 && 
            (
                <div className="dte-section">
                    <div className="dte-subsection">
                        <label className="dte-subsection-title">Otros documentos asociados</label>
                        <TablaDocsAsociados sinAcciones={true} />                    
                    </div>
                </div>
            )
            }

            {/* <InputForm type = 'checkbox' label = 'Mostrar detalle' name = 'mostrarDetalle' checked = {mostrarMontos} onChange = {(e: any) => setMostrarMontos(!mostrarMontos)}/> */}
            <div className="tab-plane">
                <div className="table-facturacion-resp">
                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                {notasRemisionAsociadas.length > 0 &&
                                    <td>Nota de remisión</td>
                                }
                                <td>Cantidad</td>
                                <td>Unidad de medida</td>
                                <td>Tipo</td>
                                <td>Descripción</td>
                                <td>Precio unitario</td>
                                <td>Otros impuestos</td>
                                <td>Descuento</td>
                                <td>Ventas gravadas</td>
                                <td>Ventas exentas</td>
                                <td>Ventas no sujetas</td>
                                <td>Ventas no gravadas</td>
                            </tr>
                        </thead>
                        <tbody>
                        {tableProductos.map((producto, index) => {
                                const digitos = getDigitosCalculables(datos?.codigo_empresa)
                                const {precioUni: precioUnitario, descuento, venta} = montosDeLineaCcf(producto)
                                const gravadas = venta
                                const exentas = venta
                                const noSujeto = venta
                                const detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '03', producto, venta);

                                return(
                                <tr>
                                    {notasRemisionAsociadas.length > 0 &&
                                        <td data-label="Nota de remisión">{producto.notaRemisionId ?? 'N/A'}</td>
                                    }
                                    <td data-label="Cantidad">{producto.cantidad}</td>
                                    <td data-label="Unidad de medida">{unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                    <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'}${producto.noGravado ? ' no gravado' : producto.exento ? ' exento' : ''}`}</td>
                                    <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                    <td data-label="Precio unitario">{precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits:digitos, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                    <td data-label="Descuento">{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits:digitos, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Ventas gravadas">{(!producto.exento && !producto.noSujeto && !producto.noGravado) ? (isNaN(gravadas) ? '$0.00' : gravadas.toLocaleString('es-SV', { minimumFractionDigits: 2, maximumFractionDigits: digitos, style: 'currency', currency: 'USD' })) : '$0.00'}</td>
                                    <td data-label="Ventas exentas">{(producto.exento && !producto.noGravado) ? (isNaN(exentas) ? '$0.00' : exentas.toLocaleString('es-SV', {minimumFractionDigits: 2,  style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                    <td data-label="Ventas no sujetas">{(producto.noSujeto && !producto.noGravado) ? (isNaN(noSujeto) ? "$0.00" : noSujeto.toLocaleString("es-SV", { minimumFractionDigits: 2, maximumFractionDigits: digitos, style: "currency", currency: "USD" })) : "$0.00"}</td>
                                    <td data-label="Ventas no gravadas">{producto.noGravado ? (isNaN(gravadas) ? "$0.00" : gravadas.toLocaleString("es-SV", { minimumFractionDigits: 2, maximumFractionDigits: digitos, style: "currency", currency: "USD" })) : "$0.00"}</td>
                                </tr>
                            )})}
                        </tbody>
                    </table>
                </div>
                    <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                    <div className="cf-calculos-producto">
                        <table>
                            <tbody>
                                <tr className="cf-subtotal">
                                    <td>Suma de operaciones</td>
                                    <td>{formatearNumEmpresa(calculosProductos().sumaOperacionesBruta, datos.codigo_empresa)}</td>
                                </tr>
                                {calculosProductos().descuentoGlobal > 0 && (
                                <tr className="cf-descuento">
                                    <td>Descuento global</td>
                                    <td>-{formatearNumEmpresa(calculosProductos().descuentoGlobal, datos.codigo_empresa)}</td>
                                </tr>
                                )}
                                <tr className="cf-subtotal">
                                    <td>Impuesto al Valor Agregado 13%</td>
                                    <td>{formatearNumEmpresa(calculosProductos().iva, datos.codigo_empresa)}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Otros impuestos</td>
                                    <td>{formatearNumEmpresa(calculosProductos().otrosImpuestos, datos.codigo_empresa)}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Subtotal</td>
                                    <td>{formatearNumEmpresa(calculosProductos().subtotal, datos.codigo_empresa)}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>IVA percibido 1%</td>
                                    <td>{formatearNumEmpresa(calculosProductos().ivaPercibido, datos.codigo_empresa)}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>IVA retenido 1%</td>
                                    <td>{formatearNumEmpresa(calculosProductos().ivaRetenido, datos.codigo_empresa)}</td>
                                </tr>
                                <tr className="cf-descuento">
                                    <td>Retencion renta 10%</td>
                                    <td>{formatearNumEmpresa(calculosProductos().retencionRenta, datos.codigo_empresa)}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Total Otros Montos No Afectados</td>
                                    <td>{formatearNumEmpresa(calculosProductos().totalNoGravado, datos.codigo_empresa)}</td>
                                </tr>
                                {propinaConfig?.propina_activa &&(
                                    <tr className="cf-descuento">
                                        <td>Monto propina {(propinaConfig.cantidad_propina * 100).toFixed(0)}%</td>
                                        <td>
                                            {
                                                formCliente.propina? formatearNum(calculosProductos().propina): "$0.00"
                                            }
                                        </td>
                                    </tr>
                                )}
                                <tr className="cf-total">
                                    <td>Total</td>
                                    <td>{formatearNumEmpresa(calculosProductos().total, datos.codigo_empresa)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
            <div className='dt-card w-100 text-center' style={{padding: 0}}>
            {response_QRcode ? <div className='dt-card-grid-3c'>
              {response_QRcode && <div>
                <img src={response_QRcode} alt='qr' className='dt-img-qr'/>
              </div>}
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
              </div>
            </div> :
            <div className={'dt-card-grid-2c'}>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
            </div> }
            </div>
        </div>
        </div>
        </div>
    )
}